import *  as commonActions from "../../common/actions"
import { errorMessage } from '../../../utils'
import {
    getAllBulbDevicesAPI,
    getSingleBulbDeviceAPI,
    getbulbDeviceHistoryBySerialNoAPI
} from './apis'
import { DownloadCSVAllDevicesAPI } from "../../common/apis";

export const GET_BULB_DEVICES_REQUEST = 'GET_BULB_DEVICES_REQUEST';
export const GET_BULB_DEVICES_SUCCESS = 'GET_BULB_DEVICES_SUCCESS';
export const GET_BULB_DEVICES_FAILED = 'GET_BULB_DEVICES_FAILED';

export const getAllBulbDevices = (filters) => dispatch =>

    new Promise((resolve, reject) => {
        dispatch({
            type: GET_BULB_DEVICES_REQUEST
        })
        getAllBulbDevicesAPI(filters).then(res => {
            dispatch({
                type: GET_BULB_DEVICES_SUCCESS,
                payload: res && res.info || {}
            })
            return resolve(res)
        }).catch(err => {
            dispatch({
                type: GET_BULB_DEVICES_FAILED
            })
            dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
            return reject(err)
        })
    })

export const GET_SINGLE_BULB_REQUEST = 'GET_SINGLE_BULB_REQUEST';
export const GET_SINGLE_BULB_SUCCESS = 'GET_SINGLE_BULB_SUCCESS';
export const GET_SINGLE_BULB_FAILED = 'GET_SINGLE_BULB_FAILED';

export const getSingleBulbDevice = (id) => dispatch =>

    new Promise((resolve, reject) => {
        dispatch({
            type: GET_SINGLE_BULB_REQUEST
        })
        getSingleBulbDeviceAPI(id).then(res => {
            dispatch({
                type: GET_SINGLE_BULB_SUCCESS,
                payload: res && res.info || {}
            })
            return resolve(res)
        }).catch(err => {
            dispatch({
                type: GET_SINGLE_BULB_FAILED
            })
            dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
            return reject(err)
        })
    })

export const GET_BULB_DEVICE_HISTORY_REQUEST = 'GET_BULB_DEVICE_HISTORY_REQUEST';
export const GET_BULB_DEVICE_HISTORY_SUCCESS = 'GET_BULB_DEVICE_HISTORY_SUCCESS';
export const GET_BULB_DEVICE_HISTORY_FAILED = 'GET_BULB_DEVICE_HISTORY_FAILED';

export const getBulbDeviceHistoryBySerialNo = (serialNo) => dispatch =>
    new Promise((resolve, reject) => {
        dispatch({
            type: GET_BULB_DEVICE_HISTORY_REQUEST
        })
        getbulbDeviceHistoryBySerialNoAPI(serialNo).then(res => {
            const { info = [] } = res || {}
            dispatch({
                type: GET_BULB_DEVICE_HISTORY_SUCCESS,
                payload: info
            })
            // dispatch(commonActions.openSnackbarsState({ message: res && res.message }))
            return resolve(res)
        }).catch(err => {
            dispatch({
                type: GET_BULB_DEVICE_HISTORY_FAILED
            })
            dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
            return reject(err)
        })
    })

    
    export const DownloadCSVAllDevices = () => dispatch => {
        return new Promise((resolve, reject) => {
            DownloadCSVAllDevicesAPI().then(res => {
                return resolve(res)
            }).catch(err => {
                dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
                return reject(err)
            })
        })
    }